import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { QuestionType } from '../question-type';
import { EssayQuestion } from '../questions';
import { QuestionRelease } from './question-release';
import { Result, UniqueEntityID } from '@digibricks/core';
export var EssayQuestionRelease = /*#__PURE__*/function (_QuestionRelease) {
  _inherits(EssayQuestionRelease, _QuestionRelease);

  var _super = _createSuper(EssayQuestionRelease);

  function EssayQuestionRelease() {
    _classCallCheck(this, EssayQuestionRelease);

    return _super.apply(this, arguments);
  }

  _createClass(EssayQuestionRelease, [{
    key: "cloneExtendedProps",
    value: function cloneExtendedProps(question, newQuestionProps, hasCorrectAnswer, showExplanation) {
      var props = _objectSpread(_objectSpread({}, newQuestionProps), showExplanation ? {
        explanation: this.props.explanation
      } : '');

      return EssayQuestionRelease.create(props);
    }
  }, {
    key: "convertToQuestion",
    value: function convertToQuestion() {
      var baseProps = _get(_getPrototypeOf(EssayQuestionRelease.prototype), "convertToQuestionProps", this).call(this);

      var essayQuestionOrError = EssayQuestion.create(_objectSpread({}, baseProps));
      return essayQuestionOrError.getValue();
    }
  }], [{
    key: "create",
    value: function create(props) {
      var resultOrError = this.validate(props);

      if (resultOrError.isFailure) {
        return Result.fail(resultOrError.error);
      }

      var basePropsOrError = _get(_getPrototypeOf(EssayQuestionRelease), "createBaseProps", this).call(this, props);

      if (basePropsOrError.isFailure) {
        return Result.fail(basePropsOrError.error);
      }

      var essayQuestionReleaseProps = _objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
        type: QuestionType.Essay
      });

      return Result.ok(new EssayQuestionRelease(essayQuestionReleaseProps, new UniqueEntityID(props.id)));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var basePropsOrError = _get(_getPrototypeOf(EssayQuestionRelease), "fromJsonBase", this).call(this, data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        return this.create(_objectSpread({}, basePropsOrError.getValue()));
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return EssayQuestionRelease;
}(QuestionRelease);